"use client";
import { useScroll } from "@/utils/getScroll";
import { useEffect, useState } from "react";
import { WidgetProps } from "@/types/types";
import MobileMenu from "./MobileMenu";
import DeskMenu from "./DeskMenu";

export const Menu = ({ data, isMobile, isApple, dailyPdf }: WidgetProps) => {
  // const { menus, status } = useMenus(pulseConfig);

  const [scrolled, setScrolling] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMac, setIsMac] = useState(false);

  // const menus = data?.menus["h-main"] || [];

  useEffect(() => {
    if (!isApple) {
      setIsMac(false);
      setIsLoading(false);
      return;
    }

    const checkMac = () => {
      setIsLoading(true);
      try {
        const width = window.innerWidth;
        setIsMac(width >= 1280);
        setIsLoading(false);
      } catch (error) {
        console.error("Error detecting Mac device:", error);
        setIsLoading(false);
      }
    };

    checkMac();
  }, [isApple]);

  const { scrollDirection } = useScroll();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 180;
      if (isScrolled !== scrolled) {
        setScrolling(isScrolled);
      }

      if (window.scrollY === 0) {
        setScrolling(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);

  return (
    <>
      {/* status === "success" && */}
      {!isLoading ? (
        <>
          {isMobile && !isMac ? (
            <MobileMenu
              menus={data}
              pdfData={dailyPdf}
              scrollDirection={scrollDirection}
            />
          ) : (
            <>
              <DeskMenu
                menus={data}
                scrolled={scrolled}
                scrollDirection={scrollDirection}
                pdfData={dailyPdf}
              />
            </>
          )}
        </>
      ) : (
        // <MenuSkeleton isMobile={isMobile} />
        ""
      )}
    </>
  );
};
